import React from "react";
import {
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import CardHeader from "./CardHeader";
import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import { FileLink } from "../../File";

function Info({ label, value, sx }) {
  return (
    <Typography variant="body1" sx={sx}>
      <strong>{label}</strong>
      <br />
      {value}
    </Typography>
  );
}

export function PaymentCard({ client }) {
  const theme = useTheme();

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <CardHeader
          title="K vyřízení"
          faIcon={faMoneyBill}
          color={theme.palette.info.main}
        />
        <Stack spacing={1} direction="column" sx={{ mb: 3 }}>
          {client.blocker != null && (
            <Info
              label="Blocker"
              value={client.blocker}
              sx={{ color: theme.palette.error.main }}
            />
          )}
          {client?.blockers?.map((blocker, i) => (
            <Box key={i}>
              <Typography>{blocker.text}</Typography>
              {blocker.file != null && (
                <FileLink
                  fileInfo={blocker.file}
                  details={blocker.file.details}
                />
              )}
            </Box>
          ))}
          {client.blocker == null && !client.blockers?.length && (
            <Typography variant="body1">Vše v pořádku.</Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
